"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { useToast } from "@/hooks/useToast";

export default function Navigation() {
  const pathname = usePathname();
  const router = useRouter();
  const { data: session } = useSession();
  const { toast } = useToast();

  const navItems = [
    {
      href: "/",
      label: "홈",
      icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
      requireAuth: false,
    },
    {
      href: "/reservation",
      label: "수강",
      icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
      requireAuth: true,
    },
    {
      href: "/customer-service",
      label: "공지",
      icon: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
      requireAuth: true,
    },
  ];

  const handleNavClick = (e: React.MouseEvent, item: (typeof navItems)[0]) => {
    if (item.requireAuth && !session) {
      e.preventDefault();
      toast.info("로그인이 필요한 페이지입니다. 먼저 로그인해주세요.");
      router.push("/");
    }
  };

  return (
    <nav className="bg-surface border-b">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-center gap-16">
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          return (
            <Link
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item)}
              className={`flex flex-col items-center gap-1 transition ${
                isActive
                  ? "text-blue-500 font-semibold"
                  : "text-text hover:text-blue-500"
              }`}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={item.icon}
                />
              </svg>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
